module.exports = __webpack_public_path__ + "2688cf832e4fb63543e50fd58a2a12d3.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/sounds/send-message.ogg
// module id = 1126
// module chunks = 0